import Icon from '../components/Icon.vue'

Icon.register({"user":{"width":512,"height":512,"paths":[{"d":"M256 0C344.4 0 416 71.6 416 160S344.4 320 256 320 96 248.4 96 160 167.6 0 256 0zM439.3 333.8L368 316C293 369.9 202.2 357.9 144 316L72.7 333.8C30 344.5 0 382.9 0 427V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V427C512 382.9 482 344.5 439.3 333.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/user.js
// module id = null
// module chunks = 